import type { ReactNode } from 'react';

export const symbol_directions_railway_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M197-80q-10.5 0-14.25-9.5T186-106l54-54h480l54 54q7 7 3.46 16.5T764-80H197Zm82-120 43-44h-29q-55.1 0-94.05-38.66Q160-321.31 160-376v-267q0-128 93-202t227-74q134 0 227 74t93 202v267q0 54.69-38.95 93.34Q722.1-244 667-244h-30l44 44H279Zm14-104h374q30.42 0 51.71-21T740-376v-168H220v168q0 30 21.29 51T293-304Zm230.5-77.5Q541-399 541-424t-17.5-42.5Q506-484 481-484t-42.5 17.5Q421-449 421-424t17.5 42.5Q456-364 481-364t42.5-17.5ZM220-604h520v-39q0-27-6-51t-17-45H243q-11 21-17 45t-6 51v39Zm73-195h374q-35-29-83.5-44.5T480-859q-55 0-103.5 15.5T293-799Zm187 255Zm0-255Z"
		/>
	</svg>
);
